/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import { Icon } from "@mui/material";
import MDButton from "components/MDButton";

export default function TableData() {


    const formTemplateRows = (data, onPress) => {
        let result = [];
        for (let dt of data) {
            result.push({
                name: dt.template_name,
                action: <MDButton variant="outlined" color="info" iconOnly onClick={() => { onPress(dt) }}>
                    <Icon>edit</Icon>
                </MDButton>
            });
        }
        return result
    }

    return {
        formTemplateRows,
        templateHeaders: [
            { Header: "Name", accessor: "name", align: "left" },
            { Header: "Action", accessor: "action", align: "center" },
        ],

    };
}
